<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    后瑞站<br>
站点介绍<br>
后瑞站位于深圳市宝安区福永镇的后瑞村和兴围村附近，车站沿宝安大道路中设置，位于宝安大道和机场南路交口以南，距离机场南路约460米，该站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:24	23:03	1号线	2分钟	4分40秒<br>
机场东	06:18	00:06	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:23	23:03	1号线	3分45秒	5分45秒<br>
机场东	06:23	00:03	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:23	00:03	1号线	3分45秒	5分45秒<br>
机场东	06:23	01:03	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
宝安大道东侧、凯成二路北、后瑞社康中心西部硅谷、黄田派出所、黄田小学、黄田村<br><br>
B出入口:<br>
宝安大道东侧 、壹航城、维也纳国际酒店、后瑞华庭、兴围村<br><br>
C出入口:<br>
宝安大道西、侧航站四路<br><br>
D出入口:<br>
宝安大道西侧、深圳邮件处理中心、深圳机场海关保税物流中心(B型)无、维也纳好眠国际酒店<br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 后瑞地铁站①<br>
暂无线路停靠<br><br>
B出入口:<br>
公交站名： 后瑞地铁站<br>
338、615、B804、B827、M249、M472、M419、M433、M530、M387<br><br>
C出入口:<br>
公交站名： 后瑞地铁站②<br>
338、615、B827、M419、M433、530<br><br>
D出入口:<br>
公交站名： 后瑞地铁站 ③<br>
M472<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>